import * as React from "react";

function MilitarySvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={27.634}
      height={32.477}
      {...props}
    >
      <path
        d="M18.751 17.387v-7.9l-4.935 2.467-4.935-2.467v7.9l4.935 2.467z"
        fill="#ff7b16"
      />
      <path
        d="M-.002 0v1.974h2.961v12.453l3.95 1.973V1.974h1.974v5.311l4.935 2.467 4.935-2.467V1.974h1.974V16.4l3.948-1.974V1.974h2.961V0zM15.866 24.013l-2.05-4.154-2.05 4.154-4.584.666 3.317 3.233-.783 4.565 4.1-2.156 4.1 2.154-.783-4.564 3.317-3.233z"
        fill="#ff7b16"
      />
    </svg>
  );
}

export default MilitarySvg;
